import styled from "styled-components";
import { MetricCard } from "./MetricCard";
import type { MetricCardProps } from "./type";

const CardContainer = styled.div<{ itemCounter: number }>`
  display: grid;
  grid-template-columns: repeat(${({ itemCounter }) => itemCounter}, 1fr);
  gap: 8px;

  @media (min-width: 768px) {
    gap: 12px;
  }
`;

type MetricCardsProps = {
	metrics: MetricCardProps[];
};

export const MetricCards: React.FC<MetricCardsProps> = ({ metrics }) => {
	return (
		<CardContainer itemCounter={metrics.length}>
			{metrics.map((metric) => (
				<MetricCard key={metric.title} {...metric} />
			))}
		</CardContainer>
	);
};
